export default __webpack_public_path__ + "static/media/ed2mit2021tuto_A01.01-big-data-technologies-v03.b648937f.pdf";